import { render } from "./ApiTokenManager.vue?vue&type=template&id=0e4629dd"
import script from "./ApiTokenManager.vue?vue&type=script&lang=js"
export * from "./ApiTokenManager.vue?vue&type=script&lang=js"
script.render = render

export default script